import { render } from "./MoreLess.vue?vue&type=template&id=d40247dc"
import script from "./MoreLess.vue?vue&type=script&lang=js"
export * from "./MoreLess.vue?vue&type=script&lang=js"

import "./MoreLess.vue?vue&type=style&index=0&id=d40247dc&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__